export enum PouchShortageStatus {
    YES = 'YES',
    NO = 'NO'
  }